import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../../../Actions/commonActions";
import AlertSmall from "../../../../Components/AlertSmall";
import EditSubscriptionForm from "../../../../Components/Customer/VOSS/Subscriptions/EditSubscriptionForm";
import Spinner from "../../../../Components/Fundamentals/Spinner/Spinner";
import forms from "../../../../Constants/forms";
import { useIntermediariesWithSelected } from '../../../../Hooks/useIntermediariesWithSelected';

const EditSubscriptionContainer = ({ blockEdit }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const intermediaries = useSelector((state) => state.CommonReducer.intermediaries);
    const subscriptionForm = useSelector((state) => state.CommonReducer.forms[forms.modifySubscription]);
    const subscription = useSelector((state) => state.SubscriptionReducer.subscription);
    const offer = useSelector((state) => state.PackageReducer.offer);

    const intermediariesWithSelected = useIntermediariesWithSelected(intermediaries, subscription);

    if (!subscriptionForm)
        return <Spinner />;

    const onChange = (form, value, key) => {
        dispatch(commonActions.changeMultiFormField(form, key, value));
    }

    return <div className="d-grid gap-24 col pl-0">
        {blockEdit && <AlertSmall alert={{ type: "warning", title: t('editsubscriptioncontainer.changesNotAllowedToSubscription') }} />}
        <div>
            <div className="d-flex justify-content-between">
                <div className="col d-flex flex-row pl-0">
                    <div className="col-10 pl-0">
                        <EditSubscriptionForm
                            intermediaries={intermediariesWithSelected}
                            form={subscriptionForm}
                            subscription={subscription}
                            offer={offer}
                            onChange={onChange}
                            blockEdit={blockEdit}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default EditSubscriptionContainer;